module.exports = __webpack_public_path__ + "media/images/gallery/constellations/lacerta/lac_lines-a4217713358389cae309a6308d37798f.gif";